import { createSlice } from "@reduxjs/toolkit";
import { getTermsAndConditionsListAPI } from "../../services/getTermsAndConditionsList";

const initialState = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const getTermsAndConditionsListSlice = createSlice({
  name: "getTermsAndConditionsList",
  initialState,
  reducers: {
    getTermsAndConditionsListInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
    },
    getTermsAndConditionsListInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.error = "";
      state.message = "";
    },
    getTermsAndConditionsListInfoFailure(state, action) {
      state.isLoading = false;
      state.message = "";
      state.error = action.payload;
      state.data = null;
    },
    getTermsAndConditionsListInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const getTermsAndConditionsListHandler = (payload) => async (dispatch) => {
  try {
    dispatch(
      getTermsAndConditionsListAction.getTermsAndConditionsListInfo(payload),
    );
    const response = await getTermsAndConditionsListAPI(payload);
    dispatch(
      getTermsAndConditionsListAction.getTermsAndConditionsListInfoSuccess(
        response,
      ),
    );
  } catch (e) {
    dispatch(
      getTermsAndConditionsListAction.getTermsAndConditionsListInfoFailure(
        e?.response?.data?.message || e?.message || String(e),
      ),
    );
  }
};

export default getTermsAndConditionsListSlice.reducer;
export const getTermsAndConditionsListAction =
  getTermsAndConditionsListSlice.actions;

